import { useEffect, useState } from 'react'
import { api } from './lib/api'
import type { Health } from './lib/api'
import { useRoute } from './lib/router'
import { Sidebar } from './components/Sidebar'
import { BadgeMode } from './components/BadgeMode'
import { SocietesPage } from './pages/Societes'
import { SocieteDetailPage } from './pages/SocieteDetail'
import { DossierAnnuelPage } from './pages/DossierAnnuel'
import { AuditPage } from './pages/Audit'

function titleFor(route: ReturnType<typeof useRoute>): string {
  switch (route.name) {
    case 'societes': return 'Portefeuille sociétés'
    case 'societe':  return `Société ${route.code}`
    case 'dossier':  return `Dossier annuel ${route.dossierId}`
    case 'audit':    return 'Audit log'
    default:         return 'TEOGEST'
  }
}

export default function App() {
  const route = useRoute()
  const [health, setHealth] = useState<Health | null>(null)

  useEffect(() => {
    let alive = true
    const load = () => api.health().then(res => {
      if (alive && res.ok) setHealth(res.data)
    })
    load()
    const timer = window.setInterval(load, 15000)
    return () => { alive = false; window.clearInterval(timer) }
  }, [])

  return (
    <div className="app">
      <Sidebar route={route} />

      <main className="main">
        <header className="topbar">
          <h1>{titleFor(route)}</h1>
          {health && (
            <BadgeMode
              writeMode={health.writeMode}
              expiresInMs={health.writeModeExpiresInMs}
            />
          )}
        </header>

        <section className="content">
          {route.name === 'societes' && <SocietesPage />}
          {route.name === 'societe' && <SocieteDetailPage code={route.code} />}
          {route.name === 'dossier' && <DossierAnnuelPage code={route.code} dossierId={route.dossierId} />}
          {route.name === 'audit' && <AuditPage />}
          {route.name === 'unknown' && (
            <div className="empty-state">
              <h2>Page inconnue</h2>
              <p>La route <code>#{route.path}</code> n'existe pas.</p>
            </div>
          )}
        </section>
      </main>

      <button className="ai-pill" aria-label="Ouvrir l'assistant Claude" type="button" disabled>
        <span className="ai-orb" aria-hidden="true"></span>
        <span>Claude — bientôt</span>
      </button>
    </div>
  )
}
